import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';
import buttonFields from './helpers/buttonFields';
// import commonFields from './helpers/commonFields';

const Nekretnine: IModel = {
  title: 'Nekretnine',
  apiPath: 'ena/porez-na-nekretnine/obveze',
  layer: 'nekretnine',
  exportFileName: 'porez_nekretnine',
  forms: {
    default: {
      fields: [
        'np_adresa',
        'korisnik_ime',
        'korisnik_oib',
        'godina',
        'is_naplativ_porez',
        'razlog_izuzeca_id',
        'porezna_zona_id',
        'stopa_poreza',
        'povrsina_m2',
        'iznos_poreza_procjena',
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'objekt_id',
        'np_adresa',
        'korisnik_ime',
        'korisnik_oib',
        'godina',
        'is_naplativ_porez',
        'razlog_izuzeca_id',
        'porezna_zona_id',
        'stopa_poreza',
        'povrsina_m2',
        'iznos_poreza_procjena',
        'modified_on',
        'docs',
        'btn_show_3d',
        'btn_show_object',
        'btn_show_photos',
      ],
      hidden: ['id', 'objekt_id', 'modified_on'],
    },
    exportExcel: {
      fields: [
        'objekt_id',
        'np_adresa',
        'korisnik_ime',
        'korisnik_oib',
        'is_naplativ_porez',
        'razlog_izuzeca_id',
        'porezna_zona_id',
        'stopa_poreza',
        'povrsina_m2',
        'iznos_poreza_procjena',
      ]
    }
  },
  fields: [
    coreFields.id,
    coreFields.gid,
    coreFields.active,

    coreFields.docs,

    coreFields.created_on,
    coreFields.modified_on,
    coreFields.modified_by,

    {
      title: 'ID Objekta',
      source: 'objekt_id',
      ttoken: 'ena:objekti.id',
      type: 'wholenum',
      filter: true,
      readonly: true,
    },
    {
      title: 'Adresa nekretnine',
      source: 'np_adresa',
      ttoken: 'ena:nekretnine.nekretnina_adresa',
      type: 'text',
      filter: true,
      readonly: true,
      width: 'full'
    },
    {
      title: 'Godina',
      source: 'godina',
      ttoken: 'ena:nekretnine.godina',
      type: 'text',
      filter: true,
      readonly: true
    },
    {
      title: 'razlog_izuzeca_id',
      source: 'razlog_izuzeca_id',
      ttoken: 'ena:nekretnine.razlog_izuzeca',
      type: 'radio',
      filter: true,
      subModel: {
        apiPath: 'ena/porez-na-nekretnine/razlozi-izuzeca',
        format: '{label}',
      },
      translate: true,
      allowDeselect: true,
      tooltip: 'ena:nekretnine.razlog_izuzeca_tooltip',
    },
    {
      title: 'korisnik_ime',
      source: 'korisnik_ime',
      ttoken: 'ena:nekretnine.korisnik_ime',
      type: 'text',
      filter: true,
      readonly: true
    },
    {
      title: 'OIB',
      source: 'korisnik_oib',
      ttoken: 'ena:nekretnine.korisnik_oib',
      type: 'text',
      export: {
        width: 20,
      },
      readonly: true
    },
    {
      title: 'povrsina_m2',
      source: 'povrsina_m2',
      ttoken: 'common.povrsina_m2',
      type: 'wholenum',
      filter: true,
      readonly: true,
    },
    {
      title: 'porezna_zona_id',
      source: 'porezna_zona_id',
      ttoken: 'ena:nekretnine.porezna_zona',
      type: 'picker',
      filter: true,
      subModel: {
        apiPath: 'ena/porez-na-nekretnine/porezne-zone',
        format: '{label}',
      },
      readonly: true,
    },
    {
      title: 'is_naplativ_porez',
      source: 'is_naplativ_porez',
      ttoken: 'ena:nekretnine.is_naplativ_porez',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'iznos_poreza_procjena',
      source: 'iznos_poreza_procjena',
      ttoken: 'ena:nekretnine.iznos_poreza_procjena',
      type: 'currency',
      currency: '€',
      filter: true,
      readonly: true,
    },
    {
      title: 'stopa_poreza',
      source: 'stopa_poreza',
      ttoken: 'ena:nekretnine.stopa_poreza',
      type: 'currency',
      currency: '€/m²',
      currencyPosition: 'right',
      filter: true,
      readonly: true,
    },
    {
      title: 'cx',
      source: 'cx',
      ttoken: '',
      type: 'numeric',
      sort: true,
      filter: true,
    },
    { 
      title: 'cy',
      source: 'cy',
      ttoken: '',
      type: 'numeric',
      sort: true,
      filter: true,
    },
    {
      title: 'cz',
      source: 'cz',
      ttoken: '',
      type: 'numeric',
      sort: true,
      filter: true,
    },
    {
      title: 'Lokacija ID',
      source: 'lokacija_id',
      ttoken: 'ena:objekti.lokacija_id',
      type: 'numeric',
      readonly: true,
    },
    coreFields.geom,
    buttonFields.show_3d,
    buttonFields.show_object,
    buttonFields.show_photos,
  ],
};

export default Nekretnine;
